var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[_c('div',{class:{ 'custom-dialog': true, 'is-visible': _vm.isVisible, [_vm.cssClass]: true },attrs:{"id":"dialog-box"},on:{"click":_vm.escapeDialog}}),_c('div',{ref:"container",class:{ 'dialog-box': true, 'is-visible': _vm.isVisible, [_vm.type]: true, [_vm.size]: true, [_vm.cssClass]: true }})])
}
var staticRenderFns = []

export { render, staticRenderFns }